module.exports = __webpack_public_path__ + "static/label-numbers-about03.f2232a71.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mb/about/label-numbers-about03.png
// module id = 542
// module chunks = 263791100135453